module.exports = __webpack_public_path__ + "static/media/yt-link.cc60c913.svg";